<template>
    <div>
        <div id="checkout">
            <!-- Checkout will insert the payment form here -->
        </div>
    </div>
</template>

<script>
import { checkClassApplicationById } from "../../api/eae";
import {
    isTestUser,
    getTestPayAmountUsd,
} from '../../utils/store'
export default {
    data() {
        return {
            application_id: this.$route.query.application_id,
            user_id: "",
            amount: "",
            currency: "",
        };
    },
    mounted() {
        this.requestApplication()
    },
    methods: {

        requestApplication() {
            if (true) {
                checkClassApplicationById(this.application_id).then((res) => {
                    let applicationInfo = res.data.data
                    let project_price_currency = applicationInfo.price_currency
                    if (project_price_currency == 'USD') {
                        project_price_currency = 'usd'
                    }
                    else if (project_price_currency == 'SGD') {
                        project_price_currency = 'sgd'
                    }else if (project_price_currency == 'GBP') {
                        project_price_currency = 'gbp'
                    } else {
                        project_price_currency = 'cny'
                    }
                    this.handleApplicationData(this.application_id, applicationInfo, project_price_currency)
                })
            }
        },
        handleApplicationData(application_id, application, currency) {
            let amount = application.service_fee + application.total_price
            if(isTestUser()){
                amount  = getTestPayAmountUsd()
            }
            let line_items = [{
                price_data: {
                    currency: currency,
                    product_data: {
                        name: application.classInfo.class_info.class_name,
                    },
                    unit_amount: amount * 100,
                },
                quantity: 1,
            }]
            this.pay(application_id, line_items);
        },

        pay(application_id, line_items) {
            // Initialize Stripe.js
            const stripe = Stripe(
                "pk_live_51P128qP6BucL4HOzvB46mZ4G6n5nyygpBo3DmJPSEPo5NSdeTsvrFxVO4PQUF3vO6WhWd1nhEgYcrQ63cFZSpMo500NFO4Pe0i"
            );

            initialize();
            // Fetch Checkout Session and retrieve the client secret
            async function initialize() {
                const fetchClientSecret = async () => {
                    const response = await fetch(
                        "https://web-backend.eae.international/Stripe/EAECourseEmbedPay.php",
                        {
                            method: "POST",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify({
                                application_id: application_id,
                                line_items: line_items,
                            }),
                        }
                    );
                    let result = await response.json();
                    const { clientSecret } = result;
                    return clientSecret;
                };

                // Initialize Checkout
                const checkout = await stripe.initEmbeddedCheckout({
                    fetchClientSecret,
                });

                // Mount Checkout
                checkout.mount("#checkout");
            }
        },
    },
};
</script>

<style></style>
